import React from 'react'
import { Redirect } from 'react-router-dom'
import { useQuery } from 'react-query'
import { useTranslate } from 'react-admin'
import { Box, Typography, makeStyles } from '@material-ui/core'
import gamedayAppIcon from '../../../../assets/images/gamedayApp.png'
import MobileApp from '../../../../components/MobileApps/MobileApp'
import getUserInvitations from '../../../../Apis/invitations/getUserInvitations'
import QueryKeys from '../../../../utils/constants/queryKeys'
import MOBILE_APP_STORE_URLS from '../../../../utils/constants/mobileAppStoreUrls'
import noOrgLandingStyles from './noOrgLanding.styles'

const SUPPORT_EMAIL = 'support@mismatch.gr'
const INVITATIONS_PATH = '/invitationsList'

const NoOrgLanding = () => {
  const translate = useTranslate()
  const useStyles = makeStyles(noOrgLandingStyles)
  const classes = useStyles()

  const userInvitations = useQuery(QueryKeys.GET_INVITATIONS, () => getUserInvitations())
  const hasPendingInvitations = userInvitations.data?.data?.length > 0

  const gamedayApp = {
    title: 'GameDay',
    androidUrl: MOBILE_APP_STORE_URLS.GAMEDAY.android,
    iosUrl: MOBILE_APP_STORE_URLS.GAMEDAY.ios,
    icon: gamedayAppIcon,
    comment: translate('ra.text.noOrgGamedayComment'),
  }

  // Answering the invitation is the way into an org, so it comes first; the landing page is for
  // accounts with nowhere to go. Rendering waits for the answer to avoid flashing one, then the other.
  if (userInvitations.isLoading) return null
  if (hasPendingInvitations) return <Redirect to={INVITATIONS_PATH} />

  return (
    <Box className={classes.wrapper}>
      <Typography className={classes.title}>{translate('ra.text.noOrgTitle')}</Typography>

      <Typography className={classes.contact}>
        {`${translate('ra.text.noOrgContact')} `}
        <a className={classes.contactLink} href={`mailto:${SUPPORT_EMAIL}`}>
          {SUPPORT_EMAIL}
        </a>
      </Typography>

      <Box className={classes.appsSection}>
        <Typography className={classes.appsTitle}>{translate('ra.text.noOrgAppsTitle')}</Typography>
        <MobileApp app={gamedayApp} />
      </Box>
    </Box>
  )
}

export default NoOrgLanding
